<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="大小">
        <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :min="10" :max="50" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.textStyle.color"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.legend.x" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.legend.y" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="布局方式">
        <t-select size="small" v-model="attribute.legend.orient">
          <t-option label="纵向" value="vertical"/>
          <t-option label="横向" value="horizontal"/>
        </t-select>
      </t-form-item>
      <t-form-item label="字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="标签" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="格式化">
        <t-input size="small" v-model="attribute.series.label.formatter" placeholder="{b} {c} ({d}%)" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.series.label.backgroundColor"/>
      </t-form-item>
      <t-form-item label="边框">
        <t-input-number size="small" v-model="attribute.series.label.borderWidth" :min="0" :max="50" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.series.label.borderColor"/>
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number size="small" v-model="attribute.series.label.borderRadius" :min="0" :max="50" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="位置">
        <t-select size="small" v-model="attribute.series.label.position">
          <t-option label="内部" value="inside"/>
          <t-option label="外侧" value="outside"/>
          <t-option label="中心" value="center"/>
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number size="small" v-model="attribute.series.label.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.series.label.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="提示" :expand="false">
      <t-form-item label="格式化">
        <t-input size="small" v-model="attribute.tooltip.formatter" placeholder="{b} {c} ({d}%)" :maxcharacter="52"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="扇区" :expand="true">
      <t-form-item label="南丁格尔图">
        <t-select size="small" v-model="attribute.series.roseType">
          <t-option label="不展示" value="false"/>
          <t-option label="圆心角" value="radius"/>
          <t-option label="扇区" value="area"/>
        </t-select>
      </t-form-item>
      <t-form-item label="外环大小%">
        <t-input-number size="small" v-model="attribute.series.radius[1]" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内环大小%">
        <t-input-number size="small" v-model="attribute.series.radius[0]" :min="0" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number size="small" v-model="attribute.series.itemStyle.borderRadius" :min="0" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="配色">
        <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
export default {
  name: "cpt-chart-pie-option",
  components: {EColorGroup, EChartPosition,CptData},
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>
</style>
